import {Injectable} from '@angular/core';
import {cloneDeep, keyBy, sortBy} from 'lodash';
import {IObjectMap} from '../models/IObjectMap';
import {COUNTRIES_LIST} from '../constants/countriesList';

export interface ICountry {
  name: string;
  dialCode: string;
  code: string;
  language: string;
}

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private countriesMap: IObjectMap<ICountry> = keyBy(COUNTRIES_LIST, 'code');

  public static getCountries(): ICountry[] {
    const sortingList = sortBy(COUNTRIES_LIST, 'name');

    return cloneDeep(sortingList);
  }

  public getCountryByDialCode(code: string) {
    return COUNTRIES_LIST.find(x => x.dialCode === code);
  }

  public dialCodeBelongsToUsCanadaIndia(code: string): boolean {
    if (COUNTRIES_LIST.find(x => x.dialCode === code && code === '+1' || code === '+91')) {
      return true;
    } else {
      return false;
    }
  }
}
